import React from 'react'
import { TitleSecondary, SpacerVertical } from '@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import { useHelpContext } from '../hooks'
import { Orientation } from './MerchantOrientation'
import HelpPageRelatedContent from './HelpPageRelatedContent'
import AllTopicsList from './Topic/AllTopicsList'
import useIsFeatureEnabled from '../hooks/useIsFeatureEnabled'
import { RESTRUCTURING_HELP_TOOL_FEATURE_FLAG } from '../constants'

function HomePage () {
  const { topics } = useHelpContext()
  const isRestructuringEnabled = useIsFeatureEnabled(RESTRUCTURING_HELP_TOOL_FEATURE_FLAG)

  if (isRestructuringEnabled) {
    return (
      <div>
        <TitleSecondary>
          <Message path='' fallback='What do you need help with?' />
        </TitleSecondary>
        <SpacerVertical small />
        <AllTopicsList topics={topics} />
      </div>
    )
  }

  return (
    <div>
      <Orientation />
      <SpacerVertical small />
      <TitleSecondary>
        <Message path='help-tool.home.topics' fallback='What do you need help with?' />
      </TitleSecondary>
      <SpacerVertical small />
      <SpacerVertical small />
      <AllTopicsList />
      <SpacerVertical small />
      <HelpPageRelatedContent
        topicSlugs={topics}
        analyticsCategory='uhqm/article-title/related/home'
      />
    </div>
  )
}

export default HomePage
